export function toUI(concept) {
    if (typeof concept === "string") {
        return {
            id: concept,
            name: concept.replace(/_/g, " ")
        }
    } else {
        return {
            id: concept.id,
            name: concept.id.replace(/_/g, " "),
            score: Math.round(concept.score * 100) / 100
        }
    }
}
